import { MainContentLayout } from 'shared/ui/layout';

import { EditAppSettings } from 'features/settings/edit';

export function EditSettingsPage() {
  return <MainContentLayout element={<EditAppSettings />} />;
}
